export default {"src":"/_next/static/media/glutenfree.45ccd451.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};